<template>
  <Toast
    group="error"
    position="bottom-left"
    style="z-index: 1007"
  >
    <template #icon>
      <font-awesome-icon
        icon="fa-regular fa-circle-exclamation"
        class="mt-[2px] text-base text-error-600"
      />
    </template>
  </Toast>
</template>

<script setup lang="ts">
import Toast from 'primevue/toast'
</script>
